
import React from 'react';
import { Link } from 'react-router-dom';

// Icons
const NewProjectIcon = () => (
  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
  </svg>
);

const NewTaskIcon = () => (
  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
);

const ScheduleIcon = () => (
  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
  </svg>
);

const SettingsIcon = () => (
  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const quickAccessItems = [
  { icon: <NewProjectIcon />, title: 'Nuevo Proyecto', path: '/projects/new', color: 'bg-blue-600' },
  { icon: <NewTaskIcon />, title: 'Nueva Tarea', path: '/tasks/new', color: 'bg-green-600' },
  { icon: <ScheduleIcon />, title: 'Agenda', path: '/calendar', color: 'bg-amber-600' },
  { icon: <SettingsIcon />, title: 'Configuración', path: '/settings', color: 'bg-[#ff1b6d]' },
];

function QuickAccess() {
  return (
    <div className="grid grid-cols-2 gap-4">
      {quickAccessItems.map((item, index) => (
        <Link
          key={index}
          to={item.path}
          className="flex flex-col items-center p-4 bg-[#252525] rounded-lg hover:bg-[#2a2a2a] transition-colors duration-200"
        >
          <div className={`p-3 rounded-full ${item.color} mb-3`}>
            <div className="text-white">{item.icon}</div>
          </div>
          <span className="text-sm font-medium text-white">{item.title}</span>
        </Link>
      ))}
    </div>
  );
}

export default QuickAccess;

